export const SORTABLE_COLUMNS = ["pmsId", "cxlId"];

export const ASIAN_TIMEZONE_MAP = {
  "Asia/Seoul": "KST",
  "Asia/Tokyo": "JST",
  "Asia/Shanghai": "CST",
  "Asia/Hong_Kong": "HKT",
  "Asia/Singapore": "SGT",
  "Asia/Bangkok": "ICT",
  "Asia/Kolkata": "IST",
  "Asia/Dubai": "GST",
  "Asia/Manila": "PHT",
  "Asia/Jakarta": "WIB",
  "Asia/Kuala_Lumpur": "MYT",
  "Asia/Ho_Chi_Minh": "ICT",
  "Asia/Taipei": "CST",
};

// Factory, not a shared object: handing out the same nested arrays would let
// an in-place mutation leak across property switches and "resets".
export const createInitialFilters = () => ({
  clients: [],
  rateplans: [],
  promoRatePlans: [],
  roomtypes: [],
});

export const INITIAL_PAGINATION = {
  size: 10,
  number: 0,
  totalElements: 10,
  totalPages: 1,
};

export const DAILY_RATES_STATUS = {
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error",
};

// The shared axios instance has no timeout; without one a hung daily-rates
// request would pin its row in LOADING forever, which re-expand deliberately
// does not retry. On timeout the entry flips to ERROR, where it does.
export const DAILY_RATES_TIMEOUT_MS = 30000;

// Pixel budget for the expanded daily-breakdown row; rsuite needs the height
// up front, so it is estimated from the stay length (and a typical footer)
// before the rates load, then recomputed from the real counts.
//
// MUST match the rendered sizing of .res-daily-breakdown in resReport.scss
// (container padding 16/24/20, header margin, 12px cell padding, 9px footer
// cell padding). The expanded container clips behind its own scrollbar when
// these drift, so a styling change there means re-measuring these values —
// same contract style as rate-plans-derived-rate/constants.js MAX_DEPTH_CLASS.
export const BREAKDOWN_HEIGHTS = {
  header: 90,
  tableHeader: 45,
  dailyRow: 45,
  footerRow: 42,
  estimatedFooterRows: 5,
  min: 180,
  max: 760,
  bottomGap: 20,
};
